define('prototypes/ObjectPrototype',['underscore','backbone','router','site_vars','challengeJs'],
    function (_,Backbone,router, site_vars,ChallengeJs) {

    Backbone.ajax = ChallengeJs;

    // global private state
    var app,
        appHttpHeaders = _([
        'X-Customer-authenticated',
        'X-Store-closed',
        'X-Cart-service-changed',
    ]), appHttpHeadersStates = {};
    function onLoadXHR(obj,xhr){
        appHttpHeaders.each(function(headerName){
            var appHeaderNextState = xhr.getResponseHeader(headerName);
            if(app && appHeaderNextState){
                appHttpHeadersStates[headerName] = appHeaderNextState;
                app.trigger(headerName,appHeaderNextState);
            }
        });
    }

    function alwaysOnXhr(data, textStatus, jqXHR){
        var obj = this;
        // success -> data, textStatus, jqXHR
        // fail -> jqXHR, textStatus, errorThrown
        switch(textStatus){
            case 'success':
                onLoadXHR(obj,jqXHR);
                break;
            case 'error':
                // data = jqXHR en cas d'erreur
                onLoadXHR(obj,data);
                break;
            // case 'parseerror':
            default:
        }
    }

    function ExecuteEachFunction(func,funcName,self){
        switch(typeof func){
            case 'string':
                ExecuteEachFunction(self[func],funcName,self);
                break;
            case 'function':
                func.call(self);
                break;
            default :
            case 'undefined':
            case 'object':
                break;
        }
    }

    return {
        country_based:true, // défini un objet qui va varier d’une instance pays à une autre
        translated:true,     // défini un objet qui va varier d'une langue à une autre
        remoteCache:'no-cache', // défini un niveau de cache distant
        privateApi:false, // défini si une API est privée ou publique (utilisée pour vérifier l'authentification)
        executeEachFunction: function(func,funcName,self){
            ExecuteEachFunction(func,funcName,self);
        },
        getLangIsoCode:function(){

         return site_vars.iso_lang.toLowerCase();
        },
        url:function(options){
            // TODO : gestion de la langue en code langue
            var self = this,
                attr = {iso_lang:site_vars.iso_lang.toLowerCase()},
                route = self.route;
            if(self.attributes){
                attr = _.extend(attr,self.attributes);
            }
            if(options){
                attr = _.extend(attr,options);
            }
            if(self.backbonePattern === 'Model' && self.isNew() && self.collection){
                // gère l’URL 'create' sur la base de la collection quand l'id n'est pas encore disponible
                route = self.collection.route;
            }
            var url = router.getApiRouteUrl(route)(attr);
            if(self.remoteCache === 'no-cache'){
                url+= (url.indexOf('?')===-1)?'?':'&';
                url+='sync='+site_vars.sync_version;
            }
            return url;
        },
        beforeInitialize : {},
        afterInitialize : {},
        initApp:function(){if(!app) app = this},
        initAppHttpHeadersChange:function(){
            var self = this;
            if(self.privateApi) {
                self.on('request', function (o, xhr, options) {
                    try{
                        xhr.always(alwaysOnXhr.bind(self));
                    }catch (err) {
                    }
                })
            }
        },
        pipeAppHttpHeaders:function(xhr){
            var self = this;
            xhr.always(alwaysOnXhr.bind(self));
            return xhr;
        }

    };
});
